import { ModuleCodes } from '../../../../models/modules';
import { WebSocketsReservationEvents, WebSocketsTripEvents } from '../../../../models/web-sockets';

const mServerTable = {
  footer: {
    selectAll: 'Seleccionar todo',
    allPageSelected: {
      text: 'Todos los {{number}} elementos de esta página están seleccionados.',
      action: 'Seleccionar los {{number}} elementos',
    },
    allPagesSelected: {
      text: 'Todos los {{number}} elementos de la tabla están seleccionados.',
      action: 'Borrar selección',
    },
  },
  noResults: 'No hay resultados',
  total: 'Total',
  generalSearch: 'Buscar',
  actions: {
    more: 'Más',
    clearFilters: 'Borrar filtros',
    hiddenColumns: 'Columnas ocultas',
    refreshTable: 'Refrescar tabla',
  },
  floatingActions: {
    extraActionsMenu: {
      button: 'Más',
      title: 'Más acciones',
    },
    selectedText: {
      single: 'Elemento seleccionado',
      many: 'Elementos seleccionados',
    },
  },
  updates: {
    [ModuleCodes.Trips]: {
      [WebSocketsTripEvents.New]: 'Nuevo',
      [WebSocketsTripEvents.Update]: 'Actualizar',
      [WebSocketsTripEvents.Cancel]: 'Cancelación',
      [WebSocketsTripEvents.StatusChange]: 'Cambio de estado',
    },
    [ModuleCodes.Reservations]: {
      [WebSocketsReservationEvents.New]: 'Nuevo',
      [WebSocketsReservationEvents.Update]: 'Actualizar',
      [WebSocketsReservationEvents.Cancel]: 'Cancelación',
      [WebSocketsReservationEvents.StatusChange]: 'Cambio de estado',
    },
  },
};

export default mServerTable;
